import type { GraphQLAuditItem } from '@internal-audit/domain/graphql-types';
import { Text, Badge, BadgeSize } from '@soteria/design-system-ve';

import { LikeDislikeButtons } from '../../LikeDislikeButtons/LikeDislikeButtons';
import * as styles from '../AuditDecisionPanel.css';
import * as spacingStyles from '../spacing.css';

interface LanguageDetectionSectionProps {
  selectedItem: GraphQLAuditItem | null;
  languageCorrect: boolean | null;
  isSessionCompleted: boolean;
  onLanguageCorrectChange: (value: boolean | null) => void;
  getDetectedLanguage: (item: GraphQLAuditItem | null) => string;
}

export function LanguageDetectionSection({
  selectedItem,
  languageCorrect,
  isSessionCompleted,
  onLanguageCorrectChange,
  getDetectedLanguage,
}: LanguageDetectionSectionProps) {
  const handleChange = (value: boolean) => {
    // If clicking the same button that's already selected, deselect it (set to null)
    const newValue = languageCorrect === value ? null : value;

    onLanguageCorrectChange(newValue);
  };

  return (
    <div className={spacingStyles.sectionContainer}>
      <Text className={styles.sectionTitle} id="language-label">
        Language Assessment
      </Text>
      <Text className={styles.assessmentQuestion}>Do you agree with the detected language?</Text>
      <div className={styles.controlRow}>
        <Badge size={BadgeSize.Small} text={getDetectedLanguage(selectedItem)} />
        <LikeDislikeButtons disabled={isSessionCompleted} name="language" value={languageCorrect} onChange={handleChange} />
      </div>
    </div>
  );
}
